{
  "kind": {
    "MINISTRY": "Ministry",
    "DG": "Directorate General",
    "DEPARTMENT": "Department",
    "SECTION": "Section",
    "DIVISION": "Division",
    "BRANCH": "Branch",
    "OTHER": "Other"
  },
  "archived": "Archived",
  "acting": "Acting",
  "vacant": "Vacant",
  "tree": {
    "label": "Organisation structure",
    "search": "Search units by code or name…",
    "clearSearch": "Clear search",
    "showArchived": "Show archived units",
    "expandAll": "Expand all",
    "collapseAll": "Collapse all",
    "unit": "Unit",
    "kind": "Kind",
    "head": "Head",
    "actions": "Actions",
    "noMatch": "No unit matches “{{query}}”.",
    "empty": {
      "title": "No units yet",
      "body": "Start with the top of the organisation (the ministry or the company), then add its directorates, departments and sections under it."
    }
  },
  "actions": {
    "new": "New unit",
    "addChild": "Add a subunit to {{name}}",
    "edit": "Edit {{name}}",
    "archive": "Archive {{name}}",
    "restore": "Restore {{name}}",
    "open": "Open {{name}}",
    "editShort": "Edit",
    "addChildShort": "Add subunit",
    "move": "Move",
    "archiveShort": "Archive",
    "restoreShort": "Restore",
    "import": "Import…"
  },
  "fields": {
    "code": "Code",
    "name": "Name",
    "nameAr": "Name in Arabic",
    "kind": "Kind",
    "parent": "Parent unit",
    "head": "Head",
    "actingHead": "Acting head",
    "actingFrom": "Acting from",
    "actingTo": "Acting until",
    "hrbp": "HR business partner",
    "defaultWorkLocation": "Default work location",
    "costCentreRef": "Cost centre reference"
  },
  "form": {
    "newTitle": "New org unit",
    "newBody": "A ministry, directorate, department, section or branch of the organisation.",
    "editTitle": "Edit org unit",
    "create": "Create unit",
    "people": "People",
    "actingPeriod": "Acting head (optional)",
    "actingBody": "While the head is away, approvals go to the acting head for these dates.",
    "hints": {
      "code": "Short and permanent: it cannot be changed later.",
      "parent": "Leave empty for a top-level unit. To change it later, use Move.",
      "actingTo": "Leave empty until further notice."
    },
    "noParent": "Top level",
    "noPerson": "Nobody",
    "choosePerson": "Choose a person",
    "searchPeople": "Search people by name or e-mail…",
    "noPeople": "Nobody matches",
    "peopleError": "People could not be loaded.",
    "noLocation": "None",
    "errors": {
      "code": "Enter a code",
      "codeFormat": "Use letters, digits, dots, dashes or underscores",
      "codeTaken": "This code is already used by another unit",
      "name": "Enter the unit's name",
      "actingHead": "Choose the acting head",
      "actingFrom": "Enter when the acting period starts",
      "actingTo": "The end cannot be before the start",
      "person": "This person is no longer active. Choose an active person",
      "location": "This work location is archived. Choose an active location"
    }
  },
  "detail": {
    "title": "Org unit",
    "path": "Under",
    "topLevel": "Top-level unit",
    "head": "Head",
    "actingHead": "Acting head",
    "actingFrom": "from {{from}}, until further notice",
    "actingRange": "{{from}} to {{to}}",
    "hrbp": "HR business partner",
    "location": "Default work location",
    "costCentre": "Cost centre reference",
    "subunits": "Subunits",
    "members": "Members ({{n}})",
    "membersHint": "People whose home unit this is (not its subunits).",
    "noMembers": "Nobody has this unit as their home unit yet.",
    "membersHidden": "Seeing the members needs the permission to view users.",
    "none": "—"
  },
  "move": {
    "title": "Move {{name}}",
    "body": "The unit moves with all its subunits and members. Approval routes follow the new place in the tree.",
    "newParent": "New parent unit",
    "confirm": "Move unit"
  },
  "archive": {
    "title": "Archive {{name}}?",
    "body": "An archived unit takes no new members and no new records. Records that already name it keep it. You can restore it later.",
    "confirm": "Archive unit",
    "restoreTitle": "Restore {{name}}?",
    "restoreBody": "The unit can again take members and records.",
    "restoreConfirm": "Restore unit"
  },
  "import": {
    "title": "Import units from a CSV file",
    "description": "Units are matched by code. New codes are created; existing units are renamed, moved, archived or restored to match the file. Units missing from the file are left alone.",
    "choose": "Choose CSV file",
    "chooseAnother": "Choose another file",
    "file": "CSV file of org units",
    "template": "Download template",
    "columns": "Columns: code, name, name_ar, kind, parent_code, status. Kind is one of {{kinds}}. Leave parent_code empty for a top unit; only status ARCHIVED archives a unit.",
    "previewing": "Checking the file…",
    "summary": "What the import changes",
    "counts": {
      "create": "New",
      "rename": "Renamed",
      "move": "Moved",
      "archive": "Archived",
      "restore": "Restored",
      "unchanged": "Unchanged",
      "error": "With errors"
    },
    "fileErrors": "The file cannot be read",
    "fixErrors": "Fix the rows marked in red in the file, then choose it again. Nothing is imported while there are errors.",
    "nothing": "The organisation already matches this file: there is nothing to import.",
    "rows": "Rows that change something or have errors",
    "line": "Line",
    "change": "Change",
    "details": "Details",
    "under": "under",
    "action": {
      "CREATE": "New",
      "ERROR": "Error"
    },
    "change_": {
      "RENAME": "Renamed",
      "KIND": "Kind changed",
      "MOVE": "Moved",
      "ARCHIVE": "Archived",
      "RESTORE": "Restored"
    },
    "applyShort": "Import",
    "apply_one": "Import {{n}} change",
    "apply_other": "Import {{n}} changes",
    "applied_one": "{{n}} unit imported",
    "applied_other": "{{n}} units imported",
    "staleTitle": "The organisation changed since the preview",
    "staleBody": "Someone changed the units, or the file is different. Preview it again to see what the import will do now.",
    "previewAgain": "Preview again",
    "becomes": "becomes",
    "fieldError": "{{field}}: {{message}}",
    "column": {
      "code": "code",
      "name": "name",
      "name_ar": "name_ar",
      "kind": "kind",
      "parent_code": "parent_code",
      "status": "status"
    },
    "errors": {
      "CSV_PARSE": "Line {{line}} cannot be read as CSV (check its quotes and commas).",
      "FILE_EMPTY": "The file is empty.",
      "UNKNOWN_COLUMN": "Unknown column “{{column}}”.",
      "DUPLICATE_COLUMN": "The column “{{column}}” appears twice.",
      "MISSING_COLUMN": "The column “{{column}}” is missing.",
      "TOO_MANY_ROWS": "The file has more than {{max}} units.",
      "CODE_INVALID": "Enter a code of up to 30 letters, digits, dots, dashes or underscores.",
      "CODE_DUPLICATE": "This code appears twice in the file.",
      "TOO_MANY_FIELDS": "The row has more fields than the header.",
      "NAME_REQUIRED": "Name is required.",
      "TOO_LONG": "At most {{max}} characters.",
      "BAD_KIND": "Use one of {{kinds}}.",
      "BAD_STATUS": "Use ACTIVE or ARCHIVED.",
      "PARENT_UNKNOWN": "Unknown parent unit.",
      "CYCLE": "A unit cannot be placed under itself or one of its subunits.",
      "PARENT_ARCHIVED": "An active unit cannot be under an archived unit.",
      "ARCHIVED_LOCKED": "An archived unit cannot change; restore it first.",
      "HAS_CHILDREN": "It still has active subunits ({{n}})."
    }
  },
  "toast": {
    "created": "Unit {{name}} created",
    "saved": "Unit {{name}} saved",
    "moved": "Unit {{name}} moved",
    "archived": "Unit {{name}} archived",
    "restored": "Unit {{name}} restored"
  },
  "errors": {
    "ORG_UNIT_CYCLE": "A unit cannot move under itself or one of its own subunits.",
    "SCOPE_RESTRICTED": "Only a user whose access covers all records can change the organisation tree.",
    "ORG_UNIT_HAS_CHILDREN": "It still has active subunits ({{n}}). Move or archive them first.",
    "ORG_UNIT_HAS_MEMBERS": "It is still the home unit of active users ({{n}}). Move them to another unit first.",
    "ORG_UNIT_HAS_SCOPED_GRANTS": "Role assignments are still limited to this unit ({{n}}). Change their scope first.",
    "ORG_UNIT_PARENT_ARCHIVED": "Its parent unit is archived. Restore the parent or choose another one first.",
    "ORG_UNIT_ARCHIVED": "This unit is archived. Restore it before changing it.",
    "ORG_UNIT_NOT_FOUND": "This unit no longer exists.",
    "WORK_LOCATION_IN_USE": "Active units use this location as their default ({{n}}). Change them first.",
    "WORK_LOCATION_ARCHIVED": "This work location is archived. Restore it before changing it."
  },
  "picker": {
    "placeholder": "Choose a unit",
    "search": "Search units…",
    "empty": "No unit matches",
    "none": "No unit",
    "archived": "Archived"
  },
  "locations": {
    "listLabel": "Work locations",
    "views": "Work location views",
    "active": "Active",
    "archived": "Archived",
    "new": "New work location",
    "newTitle": "New work location",
    "newBody": "An office, site or building where people work. Units can name it as their default.",
    "editTitle": "Edit work location",
    "create": "Create location",
    "edit": "Edit {{name}}",
    "archive": "Archive {{name}}",
    "restore": "Restore {{name}}",
    "fields": {
      "code": "Code",
      "name": "Name",
      "nameAr": "Name in Arabic",
      "governorate": "Governorate",
      "wilayat": "Wilayat",
      "address": "Address",
      "latitude": "Latitude",
      "longitude": "Longitude"
    },
    "hints": {
      "code": "Short and permanent: it cannot be changed later.",
      "wilayat": "Choose the governorate first.",
      "coordinates": "Optional. Both or neither, in decimal degrees (e.g. 23.588, 58.3829)."
    },
    "noGovernorate": "Not set",
    "noWilayat": "Not set",
    "coordinates": "Coordinates",
    "empty": {
      "title": "No work locations yet",
      "body": "Add the offices and sites where people work, by governorate and wilayat.",
      "archived": "No archived work locations."
    },
    "errors": {
      "code": "Enter a code",
      "codeFormat": "Use letters, digits, dots, dashes or underscores",
      "codeTaken": "This code is already used by another work location",
      "name": "Enter the location's name",
      "coordinates": "Enter both latitude and longitude, or neither",
      "latitude": "Latitude is a number between -90 and 90",
      "longitude": "Longitude is a number between -180 and 180"
    },
    "archiveDialog": {
      "title": "Archive {{name}}?",
      "body": "Archived locations are no longer offered to units. You can restore it later.",
      "confirm": "Archive location",
      "restoreTitle": "Restore {{name}}?",
      "restoreBody": "The location is offered to units again.",
      "restoreConfirm": "Restore location"
    },
    "toast": {
      "created": "Work location {{name}} created",
      "saved": "Work location {{name}} saved",
      "archived": "Work location {{name}} archived",
      "restored": "Work location {{name}} restored"
    }
  },
  "homeUnit": {
    "label": "Home unit",
    "none": "No home unit",
    "change": "Change",
    "changeNamed": "Change the home unit of {{name}}",
    "title": "Home unit of {{name}}",
    "body": "The unit the user belongs to. Their purchases start in it, and approvals that go to “the head of the requester's unit” follow it.",
    "field": "Home unit",
    "clear": "No home unit",
    "save": "Save home unit",
    "saved": "Home unit of {{name}} saved",
    "column": "Unit",
    "filter": "Unit",
    "allUnits": "All units"
  }
}
